export default "__VITE_ASSET__DOgmmi1G__"